import '.e5{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.e6{padding-left:1.5rem;}.ssr-plugin'
import '.e7{margin:1rem 0;}.ssr-plugin'
import '.e8{color:var(--gray-700);}.ssr-plugin'
import '.e9{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="e5 e6 e7 e8 e9"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
